import { render, staticRenderFns } from "./ReratedCoursesJ.vue?vue&type=template&id=5a96e9e1&"
import script from "./ReratedCoursesJ.vue?vue&type=script&lang=js&"
export * from "./ReratedCoursesJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports